import { render, staticRenderFns } from "./BankInternalCard.vue?vue&type=template&id=46d23a2a&scoped=true&"
import script from "./BankInternalCard.vue?vue&type=script&lang=js&"
export * from "./BankInternalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d23a2a",
  null
  
)

export default component.exports